/**
 * PRODUCT FAMILIES — what a module line carries (2026-09-29).
 *
 * The technician's `group` (kitchens | systems | indoor | outdoor) rides every def as
 * `def.family` (catalogBridge). The KITCHEN extras — the engine counter slab, the
 * kickboard, worktop / backsplash runs and the per-metre plinth line — belong to a
 * kitchen base unit and to nothing else: a wardrobe, a bed or a sofa is never a
 * worktop carrier, whatever role its category mapped to.
 *
 * ONE rule, shared by the renderers (orbit / Present / editor), the surfaces oracle,
 * the pricing engine and the GLB part classifier. Python twin: catalog_bridge.
 * is_kitchen_def / carries_worktop.
 */
export const KITCHEN_FAMILY = "kitchens";

/** the product line of a def — a def without one is a kitchen unit (legacy base library) */
export function familyOfDef(def) {
  return String((def && def.family) || KITCHEN_FAMILY).toLowerCase();
}

export function isKitchenDef(def) {
  return familyOfDef(def) === KITCHEN_FAMILY;
}

/** the wizard family word → the technician's product line (kitchen → kitchens, legacy
 *  wardrobe → systems, sofa → indoor) */
export function familyGroupOf(wizardFamily) {
  const f = String(wizardFamily || "kitchen").toLowerCase();
  return { kitchen: "kitchens", kitchens: "kitchens", wardrobe: "systems", systems: "systems", sofa: "indoor", indoor: "indoor", outdoor: "outdoor" }[f] || "kitchens";
}

/** does this module carry a worktop (engine counter, worktop runs, the top-slab
 *  geometric guess)? Only a KITCHEN base unit or appliance. */
export function carriesWorktop(def) {
  if (!def) return false;
  if (!isKitchenDef(def)) return false;
  return def.role === "cabinet-base" || def.role === "appliance";
}

/** the GLB classifier options for a module: a thin slab across the very top of a
 *  module that carries no worktop (tall / wall / furniture) is its carcass top board,
 *  never a worktop to paint. No def (legacy callers) keeps the old behaviour. */
export function geoOptsForDef(def) {
  if (!def || !def.role) return { worktop: true };
  return { worktop: carriesWorktop(def) };
}

/** a unit as tall as a column IS a column, whatever its category says */
export const TALL_MIN_M = 1.4;

/** a module that MAY carry a worktop — unknown role (legacy callers) keeps the old behaviour */
export function mayCarryWorktop(def) {
  if (!def || !def.role) return true;
  return carriesWorktop(def);
}
